// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3oCHO","header":"ReportDetails_header__PpxM7","title":"ReportDetails_title__3eLcl","left":"ReportDetails_left__20Yef"};